import { createContextFunction } from '../utils'

export const [ReadOnlyProvider, useReadOnly] = createContextFunction<boolean>(
  'readOnly',
  function () {
    return false
  },
)
